const normalizePublicAssetPath = (path, fallback) => {
  const value = (path || '').trim()
  if (!value) {
    return fallback
  }
  if (value.startsWith('http://') || value.startsWith('https://') || value.startsWith('/')) {
    return value
  }
  return `/${value}`
}

// export const host = 'http://localhost:5785'
export const host = (process.env.REACT_APP_BACKEND_HOST || 'https://backend.vinapoolwin.com').trim()
export const clientId = (process.env.REACT_APP_CLIENT_ID || 'vinapool').trim()
export const imageHost = (process.env.REACT_APP_IMAGE_HOST || 'https://image.mekonglott.com').trim()

const CLIENT_DISPLAY_NAME = {
  vinapool: 'Vinapool',
  luckylott: 'Luckylott',
}

export const clientName = (
  process.env.REACT_APP_CLIENT_NAME ||
  CLIENT_DISPLAY_NAME[clientId] ||
  clientId
).trim()

export const clientLogo = normalizePublicAssetPath(process.env.REACT_APP_CLIENT_LOGO, '/logo-vinapool.svg')
export const clientIcon = normalizePublicAssetPath(process.env.REACT_APP_CLIENT_ICON, '/favicon.ico')

export const RSA_PUBLIC_KEY = '-----BEGIN PUBLIC KEY-----\n'+
'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAhEKxDENVH8MN/w1uPpAN\n'+
'TDGoLP9a4BefeocwSWE1AZGPROKvNeOnyhoqVK04lCW5IPsRt2KiRPEZ9u56rIqp\n'+
'IpNEo3cVwLwFTZz0iLi1eBCsZzrc1j1uXQwM8I/037Qrc3jlTGNzv2r6wSCNzTwo\n'+
'V6VCAGEx7oeM2W+ozvJP7IWlmJLH9cZdeJLDLuAwpssDQ82gA1S3m6GvJkhMjhUb\n'+
'5iarhc1zPM49jEOXEWn40amGQKCYcjsiZzz+3a0PIhDfAWqXYfNyx9gg+tA8QVQa\n'+
'bNdkZVBZG7KrfbtsJX4GAZR261/pUfA25AzRnkQFE0S0COboGp+9xBBLtEBAFrCh\n'+
'ywIDAQAB\n'+
'-----END PUBLIC KEY-----';